"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntermediateFieldSchema = void 0;
const _imports_1 = require("./_imports");
const _shared_1 = require("./_shared");
// Zod schema for CommonIntermediateField.IntermediateField
exports.IntermediateFieldSchema = _imports_1.z.object({
    field: _imports_1.z.string(),
    config: _shared_1.FormulaConfigSchema.extend({ type: _imports_1.z.literal('formula') }),
});
/**
 * Portfolio Covenants operate generically in the following manner:
 *
 * Queries (Athena and Postgres) have variables that are primitives.
 * There is a special runtime variable `triggerDate` that always injected into the variable list.
 *
 * These variables can be then used in formulas to determine what parameterized values should be passed to a query implementation.
 * A common pattern will be to have `triggerDate` variable passed to a formula to determine `startDate` of a query
 * ie. startDate is the first of day of the previous month relative to the triggerDate
 *
 * The resulting evaluation of the formulas are then passed as parameters to the query implementation.
 * Postgres queries will pass as params to a method as there may be additional application logic.
 * Athena params are simply bound to the query with `?` binding pattern.
 *
 * The results of the athena or pg query are then made available to the intermediate fields (formula) from further evaluation.
 *
 * Athena results will be the first row of the resulting query, accessible by queryName.columnName in intermediate fields
 * ColumnNames are eagerly stored/validated in the config, unexpected column names are omitted in the response.
 *
 * Postgres results will resolve to singular primitive (application code wrapping the pg query will handle this), accessible by `name` in intermediate fields.
 *
 */
//# sourceMappingURL=CommonIntermediateField.js.map